<template>
  <div>
    <span
      :class="{ hideAriaLabel: hideLabel }"
      role="alert"
      :aria-label="timerAriaLabel"></span>
    <div
      v-if="interactionCountdown >= 0 && interactionCountdown <= sessionInteraction.interactionDuration">
      <Tooltip
        right>
          <v-avatar
          :color="timerColor"
          class="white--text ml-3 mt-3"
          size="37">{{formattedInteractionCountdown}}</v-avatar>
        <template v-slot:text>
          {{formattedInteractionCountdownTooltip}}
        </template>
      </Tooltip>
    </div>
    <div v-else-if="interactionOffsetCountdown > 0 && interactionCountdown <= sessionInteraction.interactionDuration">
      <Tooltip
        right>
        <v-avatar
          class="grey darken-3 white--text ml-3 mt-3"
          size="35">{{interactionOffsetCountdown}}</v-avatar>
        <template v-slot:text>
          Class will resume in {{interactionOffsetCountdown}} seconds
        </template>
      </Tooltip>
    </div>
    <div v-else-if="interactionOffsetCountdown <= 0">
      <v-chip
        class="pp-interaction-title grey"
        dark
        role="alert">
        Class resuming...
      </v-chip>
    </div>
  </div>
</template>

<script>
/* global _ */
import { mapState, mapMutations, mapGetters } from 'vuex';
export default {
  name: 'liveSessionInteractionCountdown',
  props: [
    'interaction',
  ],
  data() {
    return {
      hideLabel: true,
    };
  },
  methods: {
    ...mapMutations('interactions',[
      'updateInteractionMetaPastInteractionOffset',
      'updateInteractionMetaPastSessionTime',
    ]),
  },
  computed: {
    ...mapState('player', [
      'bulb',
      'isLiveSession',
      'liveSessionTimeArray',
      'liveSessionUnixTime',
    ]),
    ...mapGetters('player', [
      'branding',
    ]),
    formattedInteractionCountdown() {
      if (this.isLiveSession) {
        const countdown = Math.trunc(this.sessionInteraction.unixDisplayOutTime - this.liveSessionUnixTime - this.sessionInteraction.interactionOffset);
        if (countdown > 59) {
          return `${Math.floor(countdown / 60)}:${Math.floor(countdown % 60) < 10 ? '0' + Math.floor(countdown % 60) : Math.floor(countdown % 60)}`;
        } else {
          return countdown;
        }
      }
      return 0;
    },
    formattedInteractionCountdownTooltip() {
      if (this.interaction.interactionType === 'pause_q' && this.sessionInteraction.interactionDuration >= 300) {
        return `Class will resume in ${this.formattedInteractionCountdown}`;
      }
      return `${this.formattedInteractionCountdown} left to answer`;
    },
    interactionCountdown() {
      if (this.isLiveSession) return Math.trunc(this.sessionInteraction.unixDisplayOutTime - this.liveSessionUnixTime - this.sessionInteraction.interactionOffset);
      return 0;
    },
    interactionMeta() {
      return this.$store.getters['interactions/interactionMeta'](this.interaction.id) || {};
    },
    interactionOffsetCountdown() {
      return Math.trunc(this.sessionInteraction.unixDisplayOutTime - this.liveSessionUnixTime);
    },
    sessionInteraction() {
      return _.find(this.liveSessionTimeArray, { 'interactionId': this.interaction.id });
    },
    timerAriaLabel() {
      let minutes = 0;
      if (this.sessionInteraction.interactionDuration >= 60) minutes = Math.floor(this.sessionInteraction.interactionDuration / 60);
      const seconds = this.sessionInteraction.interactionDuration - (minutes * 60);
      // Pause interaction greater than 5 minutes - treat like class break
      if (this.interaction.interactionType === 'pause_q' && this.sessionInteraction.interactionDuration >= 300) {
        return `Class will resume in ${minutes ? minutes + ' minutes and' : ''} ${seconds} seconds.`;
      }
      return `You have ${minutes ? minutes + ' minutes and' : ''} ${seconds} seconds left to answer.`;
    },
    timerColor() {
      if ([883, 1470, 2233, 2234, 2235, 2611].includes(_.get(this.bulb, 'masterTeacher.school.id'))) {
        return '#ff6800';
      }
      return this.branding.activeColor;
    },
  },
  watch: {
    'interactionCountdown' (n, o) {
      if (n >= 0 && n <= this.sessionInteraction.interactionDuration) this.hideLabel = false;
      if (n + 3 < this.sessionInteraction.interactionDuration) this.hideLabel = true;
      if (n <= 0 && !this.interactionMeta.pastSessionTime && this.isLiveSession) this.updateInteractionMetaPastSessionTime({
        interactionId: this.interaction.id,
        pastSessionTime: true,
      });
    },
    'interactionOffsetCountdown' (n, o) {
      if (n < 1) this.updateInteractionMetaPastInteractionOffset({
        interactionId: this.interaction.id,
        pastInteractionOffset: true,
      });
    },
  },
  mounted() {
    if (
      this.interaction.interactionText.includes('app.sli.do')
      || this.interaction.interactionText.includes('Table of Contents')
    ) this.hideLabel = true;
  },
};
</script>

<style scoped>
  .hideAriaLabel {
    display: none !important;
  }
</style>